import React from 'react'

interface Props<T> {
	Of: React.FC<React.PropsWithChildren<T>>
	entries: Array<T>
}

export const List = <T,>({ Of, entries }: Props<T>): JSX.Element => {
	return (
		<>
			{entries.map((item, index) => (
				<Of key={index} {...item} />
			))}
		</>
	)
}
